(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nextyl-domain-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const deliveryLink=event.target.closest('.nx-domain__shipping-summary a');
    if(deliveryLink){
      const target=document.getElementById(deliveryLink.hash.slice(1));
      if(target)target.open=true;
    }
    const quantityButton=event.target.closest('[data-domain-quantity]');
    if(quantityButton){
      const control=quantityButton.closest('.nx-domain__quantity-control');
      const input=control.querySelector('input');
      if(quantityButton.dataset.domainQuantity==='increase')input.stepUp();else input.stepDown();
      control.querySelector('[data-domain-quantity="decrease"]').disabled=Number(input.value)<=1;
      input.dispatchEvent(new Event('change',{bubbles:true}));
      return;
    }
    const button=event.target.closest('[data-domain-slide]');
    if(!button)return;
    const gallery=button.closest('.nx-domain-gallery');
    const track=gallery.querySelector('.nx-domain-gallery__track');
    const slide=track.children[Number(button.dataset.domainSlide)];
    if(slide)track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  document.addEventListener('change', function(event) {
    if(event.target.matches('.nx-domain__quantity-control input')){
      const input=event.target;
      if(!Number.isFinite(Number(input.value))||Number(input.value)<1)input.value='1';
      input.closest('.nx-domain__quantity-control').querySelector('[data-domain-quantity="decrease"]').disabled=Number(input.value)<=1;
      return;
    }
    if(!event.target.matches('[data-domain-variant]'))return;
    const section=event.target.closest('.nx-domain');
    const pickup=section.querySelector('pickup-availability');
    if(pickup && typeof pickup.fetchAvailability==='function')pickup.fetchAvailability(event.target.value);
    const option=event.target.selectedOptions[0];
    section.querySelector('[data-domain-price]').textContent=option.dataset.price;
    const button=section.querySelector('[data-domain-add]');
    button.disabled=option.dataset.available!=='true';
    button.textContent=button.disabled?button.dataset.unavailable:button.dataset.ready;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nextyl-euro-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const deliveryLink=event.target.closest('.nx-euro__shipping-summary a');
    if(deliveryLink){
      const target=document.getElementById(deliveryLink.hash.slice(1));
      if(target)target.open=true;
    }
    const quantityButton=event.target.closest('[data-euro-quantity]');
    if(quantityButton){
      const control=quantityButton.closest('.nx-euro__quantity-control');
      const input=control.querySelector('input');
      if(quantityButton.dataset.euroQuantity==='increase')input.stepUp();else input.stepDown();
      control.querySelector('[data-euro-quantity="decrease"]').disabled=Number(input.value)<=1;
      input.dispatchEvent(new Event('change',{bubbles:true}));
      return;
    }
    const button=event.target.closest('[data-euro-slide]');
    if(!button)return;
    const gallery=button.closest('.nx-euro-gallery');
    const track=gallery.querySelector('.nx-euro-gallery__track');
    const slide=track.children[Number(button.dataset.euroSlide)];
    if(slide)track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  document.addEventListener('change', function(event) {
    if(event.target.matches('.nx-euro__quantity-control input')){
      const input=event.target;
      if(!Number.isFinite(Number(input.value))||Number(input.value)<1)input.value='1';
      input.closest('.nx-euro__quantity-control').querySelector('[data-euro-quantity="decrease"]').disabled=Number(input.value)<=1;
      return;
    }
    if(!event.target.matches('[data-euro-variant]'))return;
    const section=event.target.closest('.nx-euro');
    const pickup=section.querySelector('pickup-availability');
    if(pickup && typeof pickup.fetchAvailability==='function')pickup.fetchAvailability(event.target.value);
    const option=event.target.selectedOptions[0];
    section.querySelector('[data-euro-price]').textContent=option.dataset.price;
    const button=section.querySelector('[data-euro-add]');
    button.disabled=option.dataset.available!=='true';
    button.textContent=button.disabled?button.dataset.unavailable:button.dataset.ready;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nextyl-flooring-wallan"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nfw-assistance]').forEach((select) => {
    const section = select.closest('.nfw');
    const installationFields = section?.querySelector('[data-nfw-install-fields]');
    if (!installationFields) return;

    const updateFields = () => {
      installationFields.hidden = select.value !== 'Supply and installation quote';
    };

    select.addEventListener('change', updateFields);
    updateFields();
  });

  } catch(e) { console.error(e); }
})();
})();
